export const typography = {
	fontFamily: 'SUIT',
	fontWeightRegular: 400,
	fontWeightMedium: 600,
	fontWeightBold: 700,
} as const
